import React, { useEffect, useState } from 'react';
import './App.css';
import './styles/navbar.css';
import LOGO from "./images/smartlogo2.svg"
import HeroImages from "./images/homepagephones.png"
import livespaces from "./images/livespaces.png"
// import livespace from "./images/livspaces.png"

import { SplineScene } from "./components/ui/splite";
import { Card } from "./components/ui/card"
import { Spotlight } from "./components/ui/spotlight"

import { Box, Lock, Search, Settings, Sparkles } from "lucide-react";
import { GlowingEffect } from "./components/ui/glowing-effect";
 
import { Instagram, Twitter, Facebook, Linkedin, Link } from 'lucide-react';
import './index.css'
import { Resend } from 'resend';
import { cn } from "./lib/utils";

import { motion } from "framer-motion";
import { Plus, User } from "lucide-react";
import { StoryViewer, type Story } from "./components/ui/story-viewer";
import FlipTextReveal from "./components/ui/next-reveal";
import { Hero,Hero2 } from "./components/ui/animated-hero"

import { Calendar, Code, FileText, Clock } from "lucide-react";
import RadialOrbitalTimeline from "./components/ui/radial-orbital-timeline";
// import Image from "next/image";
import { Timeline } from "./components/ui/timeline";
import { Navbar } from "./components/navbar"




// Import the Legal Pages
import { TermsOfService, PrivacyPolicy } from './components/LegalPage';
import { WorldModelsThesis } from './components/thesis';
import { PlatformPage } from './components/PlatformPage';
import { Route, Routes } from 'react-router-dom';

// Create a MainContent component for the landing page
function MainContent() {
  return (
    <>
      <Navbar />
      <Hero2 />
      <SplineSceneBasic />
      <TimelineDemo />
      <DemoOne />
      <GlowingEffectDemo />
      <RadialOrbitalTimeline timelineData={timelineData} header={{
    eyebrow: "What we are building",
    title: "From raw data to a live process twins",
    subtitle: "CONNECT, GENERATE, TRANSFORM, VISUALIZE and DEPLOY — one WORLD at a time.",
  }}/>
      {/* <HeroSection /> */}
      {/* <FeaturesSection /> */}
      {/* <CountdownSection /> */}
      {/* <Demo /> */}
      
      <SignUpSection />
      <Footer />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<MainContent />} />
        <Route path="/thesis" element={<WorldModelsThesis />} />
        <Route path="/terms" element={<TermsOfService />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/platform" element={<PlatformPage />} />
      </Routes>
    </div>
  );
}

function TimelineDemo() {
  const data = [
  {
    title: "Connected Era",
    version: "2010 — 2015",
    content: (
      <div>
        {/* quote */}
        <p className="font-serif italic text-lg md:text-2xl text-neutral-900 dark:text-neutral-100 text-center leading-snug mb-6">
          “We taught the physical world to speak.”
        </p>

        {/* body */}
        <p className="text-neutral-600 dark:text-neutral-400 text-sm md:text-base leading-relaxed text-center max-w-2xl mx-auto mb-8">
          Sensors and IoT gave every machine, shelf, and vehicle a voice. For the
          first time, operational reality streamed as live data at scale — assets
          became observable in real time.
        </p>

        {/* flattening callout */}
        <div className="relative rounded-2xl bg-gradient-to-br from-neutral-100 to-neutral-50 dark:from-white/[0.06] dark:to-white/[0.02] border border-neutral-200/80 dark:border-white/10 px-6 py-5 mb-10 shadow-sm">
          <div className="flex items-center gap-2 mb-2">
            <div className="h-1.5 w-1.5 rounded-full bg-neutral-400 dark:bg-neutral-500" />
            <p className="text-[11px] font-semibold uppercase tracking-[0.2em] text-neutral-500 dark:text-neutral-500">
              The Flattening
            </p>
          </div>
          <p className="text-neutral-700 dark:text-neutral-300 text-sm leading-relaxed text-center md:text-left">
            The moment physical events became data points, their location was reduced
            to a tag in a schema. Coordinates became metadata.{" "}
            <span className="text-neutral-900 dark:text-white font-medium">
              The world arrived as rows.
            </span>
          </p>
        </div>

        {/* image grid with depth treatment */}
        <div className="grid grid-cols-2 gap-4">
          <div className="group relative rounded-xl overflow-hidden border border-neutral-200 dark:border-white/10 shadow-lg shadow-neutral-900/5">
            <img
              src="https://images.unsplash.com/photo-1584761650834-efc7932b9c4d?q=80&w=1740&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
              alt="IoT Sensors"
              width={500}
              height={500}
              className="object-cover h-32 md:h-44 lg:h-56 w-full transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/0 to-black/0" />
            <p className="absolute bottom-2.5 left-3.5 text-[11px] font-medium tracking-wide text-white/90">
              IoT Sensors
            </p>
          </div>
          <div className="group relative rounded-xl overflow-hidden border border-neutral-200 dark:border-white/10 shadow-lg shadow-neutral-900/5">
            <img
              src="https://plus.unsplash.com/premium_photo-1716824502184-f5f8816ed2ca?q=80&w=1740&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
              alt="Real Time Observability"
              width={500}
              height={500}
              className="object-cover h-32 md:h-44 lg:h-56 w-full transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/0 to-black/0" />
            <p className="absolute bottom-2.5 left-3.5 text-[11px] font-medium tracking-wide text-white/90">
              Real-World Observability
            </p>
          </div>
          <div className="group relative rounded-xl overflow-hidden border border-neutral-200 dark:border-white/10 shadow-lg shadow-neutral-900/5">
            <img
              src="https://plus.unsplash.com/premium_photo-1754507733579-20c328705ef8?q=80&w=2064&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
              alt="Smart City"
              width={500}
              height={500}
              className="object-cover h-32 md:h-44 lg:h-56 w-full transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/0 to-black/0" />
            <p className="absolute bottom-2.5 left-3.5 text-[11px] font-medium tracking-wide text-white/90">
              Smart Cities
            </p>
          </div>
          <div className="group relative rounded-xl overflow-hidden border border-neutral-200 dark:border-white/10 shadow-lg shadow-neutral-900/5">
            <img
              src="https://images.unsplash.com/photo-1612521564730-62fc7691cd85?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NTF8fHBoeXNpY3N8ZW58MHx8MHx8fDA%3D"
              alt="Building Sensors"
              width={500}
              height={500}
              className="object-cover h-32 md:h-44 lg:h-56 w-full transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/0 to-black/0" />
            <p className="absolute bottom-2.5 left-3.5 text-[11px] font-medium tracking-wide text-white/90">
              Building Sensors
            </p>
          </div>
        </div>
      </div>
    ),
  },
  {
    title: "Intelligence Era",
    version: "2015 — 2020",
    content: (
      <div>
        <p className="font-serif italic text-lg md:text-2xl text-neutral-900 dark:text-neutral-100 text-center leading-snug mb-6">
          “We learned to predict — on a flat canvas.”
        </p>

        <p className="text-neutral-600 dark:text-neutral-400 text-sm md:text-base leading-relaxed text-center max-w-2xl mx-auto mb-8">
          Cloud, data lakes, and machine learning turned raw telemetry into
          forecasts, trends, and predictive maintenance. Organizations stopped
          reacting and started anticipating.
        </p>

        <div className="relative rounded-2xl bg-gradient-to-br from-neutral-100 to-neutral-50 dark:from-white/[0.06] dark:to-white/[0.02] border border-neutral-200/80 dark:border-white/10 px-6 py-5 mb-10 shadow-sm">
          <div className="flex items-center gap-2 mb-2">
            <div className="h-1.5 w-1.5 rounded-full bg-neutral-400 dark:bg-neutral-500" />
            <p className="text-[11px] font-semibold uppercase tracking-[0.2em] text-neutral-500 dark:text-neutral-500">
              The Flattening
            </p>
          </div>
          <p className="text-neutral-700 dark:text-neutral-300 text-sm leading-relaxed text-center md:text-left">
            Every insight was rendered on a 2D canvas. A sales-decline line chart
            compresses 10,000 spatial events into one descending stroke — it answers{" "}
            <span className="font-semibold text-neutral-900 dark:text-white">when</span> and{" "}
            <span className="font-semibold text-neutral-900 dark:text-white">how much</span>, and
            structurally cannot answer{" "}
            <span className="font-semibold text-neutral-900 dark:text-white">where</span> or{" "}
            <span className="font-semibold text-neutral-900 dark:text-white">why</span>.
          </p>
        </div>

        <div className="grid grid-cols-2 gap-4">
          <div className="group relative rounded-xl overflow-hidden border border-neutral-200 dark:border-white/10 shadow-lg shadow-neutral-900/5">
            <img
              src="https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8ZGF0YSUyMGFuYWx5dGljc3xlbnwwfHwwfHx8MA%3D%3D"
              alt="AI Analytics"
              width={500}
              height={500}
              className="object-cover h-32 md:h-44 lg:h-56 w-full transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/0 to-black/0" />
            <p className="absolute bottom-2.5 left-3.5 text-[11px] font-medium tracking-wide text-white/90">
              AI Analytics
            </p>
          </div>
          <div className="group relative rounded-xl overflow-hidden border border-neutral-200 dark:border-white/10 shadow-lg shadow-neutral-900/5">
            <img
              src="https://images.unsplash.com/photo-1608222351212-18fe0ec7b13b?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Nnx8ZGF0YSUyMGFuYWx5dGljc3xlbnwwfHwwfHx8MA%3D%3D"
              alt="Data Visualization"
              width={500}
              height={500}
              className="object-cover h-32 md:h-44 lg:h-56 w-full transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/0 to-black/0" />
            <p className="absolute bottom-2.5 left-3.5 text-[11px] font-medium tracking-wide text-white/90">
              2D Data Visualization
            </p>
          </div>
          <div className="group relative rounded-xl overflow-hidden border border-neutral-200 dark:border-white/10 shadow-lg shadow-neutral-900/5">
            <img
              src="https://plus.unsplash.com/premium_photo-1661878265739-da90bc1af051?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTN8fGRhdGElMjBhbmFseXNpc3xlbnwwfHwwfHx8MA%3D%3D"
              alt="Cloud Data"
              width={500}
              height={500}
              className="object-cover h-32 md:h-44 lg:h-56 w-full transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/0 to-black/0" />
            <p className="absolute bottom-2.5 left-3.5 text-[11px] font-medium tracking-wide text-white/90">
              Cloud Data Platforms
            </p>
          </div>
          <div className="group relative rounded-xl overflow-hidden border border-neutral-200 dark:border-white/10 shadow-lg shadow-neutral-900/5">
            <img
              src="https://images.unsplash.com/photo-1526628953301-3e589a6a8b74?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTB8fGRhdGElMjBhbmFseXNpc3xlbnwwfHwwfHx8MA%3D%3D"
              alt="Machine Learning"
              width={500}
              height={500}
              className="object-cover h-32 md:h-44 lg:h-56 w-full transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/0 to-black/0" />
            <p className="absolute bottom-2.5 left-3.5 text-[11px] font-medium tracking-wide text-white/90">
              Machine Learning
            </p>
          </div>
        </div>
      </div>
    ),
  },
  {
    title: "Convergence Era",
    version: "2020 — Today",
    content: (
      <div>
        <p className="font-serif italic text-lg md:text-2xl text-neutral-900 dark:text-neutral-100 text-center leading-snug mb-6">
          “We connected everything — and projected it onto the same flat screen.”
        </p>

        <p className="text-neutral-600 dark:text-neutral-400 text-sm md:text-base leading-relaxed text-center max-w-2xl mx-auto mb-8">
          Industry 4.0 delivered cyber-physical systems, IT/OT integration, and
          autonomous operations. Every system talks to every other system — and
          every connection is rendered as another 2D dashboard.
        </p>

        <div className="relative rounded-2xl bg-gradient-to-br from-neutral-100 to-neutral-50 dark:from-white/[0.06] dark:to-white/[0.02] border border-neutral-200/80 dark:border-white/10 px-6 py-5 mb-10 shadow-sm">
          <div className="flex items-center gap-2 mb-2">
            <div className="h-1.5 w-1.5 rounded-full bg-neutral-400 dark:bg-neutral-500" />
            <p className="text-[11px] font-semibold uppercase tracking-[0.2em] text-neutral-500 dark:text-neutral-500">
              The Flattening, Compounded
            </p>
          </div>
          <p className="text-neutral-700 dark:text-neutral-300 text-sm leading-relaxed text-center md:text-left">
            The bottleneck was never data or AI. It was the rendering surface.{" "}
            <span className="text-neutral-900 dark:text-white font-medium">
              Insight kept being delivered in the one format that strips out the
              dimension where operations happen: space.
            </span>
          </p>
        </div>

        <div className="grid grid-cols-2 gap-4">
          <div className="group relative rounded-xl overflow-hidden border border-neutral-200 dark:border-white/10 shadow-lg shadow-neutral-900/5">
            <img
              src="https://images.unsplash.com/photo-1647427060118-4911c9821b82?q=80&w=1740&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
              alt="Industrial Robots"
              width={500}
              height={500}
              className="object-cover h-32 md:h-44 lg:h-56 w-full transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/0 to-black/0" />
            <p className="absolute bottom-2.5 left-3.5 text-[11px] font-medium tracking-wide text-white/90">
              Autonomous Robotics
            </p>
          </div>
          <div className="group relative rounded-xl overflow-hidden border border-neutral-200 dark:border-white/10 shadow-lg shadow-neutral-900/5">
            <img
              src="https://plus.unsplash.com/premium_photo-1688678097388-a0c77ea9ace1?q=80&w=1692&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
              alt="Smart Factory"
              width={500}
              height={500}
              className="object-cover h-32 md:h-44 lg:h-56 w-full transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/0 to-black/0" />
            <p className="absolute bottom-2.5 left-3.5 text-[11px] font-medium tracking-wide text-white/90">
              Smart Factories
            </p>
          </div>
          <div className="group relative rounded-xl overflow-hidden border border-neutral-200 dark:border-white/10 shadow-lg shadow-neutral-900/5">
            <img
              src="https://plus.unsplash.com/premium_photo-1688678097473-2ce11d23e30c?q=80&w=1340&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
              alt="Connected Sensors"
              width={500}
              height={500}
              className="object-cover h-32 md:h-44 lg:h-56 w-full transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/0 to-black/0" />
            <p className="absolute bottom-2.5 left-3.5 text-[11px] font-medium tracking-wide text-white/90">
              Connected Systems
            </p>
          </div>
          <div className="group relative rounded-xl overflow-hidden border border-neutral-200 dark:border-white/10 shadow-lg shadow-neutral-900/5">
            <img
              src="https://plus.unsplash.com/premium_photo-1682785300986-c3cdb1ac784b?q=80&w=1742&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
              alt="Digital Twin Visualization"
              width={500}
              height={500}
              className="object-cover h-32 md:h-44 lg:h-56 w-full transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/0 to-black/0" />
            <p className="absolute bottom-2.5 left-3.5 text-[11px] font-medium tracking-wide text-white/90">
              Digital Twins
            </p>
          </div>
        </div>
      </div>
    ),
  },
  {
    title: "Spatial Era (3D + time = 4D)",
    version: "You are here",
    content: (
      <div>
        <p className="font-serif italic text-lg md:text-2xl text-neutral-900 dark:text-neutral-100 text-center leading-snug mb-6">
          “Insight returns to the physical world — in four dimensions.”
        </p>

        <p className="text-neutral-600 dark:text-neutral-400 text-sm md:text-base leading-relaxed text-center max-w-2xl mx-auto mb-8">
          The first analytic surface that is 3D + time: every metric pinned to the
          exact space it occurred in, replayable hour by hour. The sales decline is
          no longer a slope —{" "}
          <span className="text-neutral-900 dark:text-white font-medium">
            it’s a region of your floor plan going dark at 2pm.
          </span>
        </p>

        {/* Era 4 payoff panel — inverted to mark the resolution */}
        <div className="relative rounded-2xl bg-neutral-900 dark:bg-white/[0.08] border border-neutral-800 dark:border-white/15 px-6 py-6 mb-10 shadow-xl shadow-neutral-900/20 dark:shadow-black/40 overflow-hidden">
          {/* corner glow accent */}
          <div className="absolute -top-16 -right-16 h-40 w-40 rounded-full bg-white/10 blur-3xl pointer-events-none" />
          <p className="text-[11px] font-semibold uppercase tracking-[0.2em] text-neutral-400 mb-4 text-center">
            What becomes decidable when insight has an address
          </p>
          <div className="grid sm:grid-cols-2 gap-x-6 gap-y-2.5">
            {[
              "Revenue, and operations mapped to real physical spaces",
              "Dead zone, the bottleneck, the queue are anomalies",
              "Live 3D digital twins animated by time",
              "Spatial root-cause analysis across connected data systems",
              "AI that reasons about operations spatially",
              "One shared view for everyone — the physical world",
            ].map((item) => (
              <div key={item} className="flex gap-2.5 items-start text-neutral-300 text-xs md:text-sm leading-relaxed">
                <svg className="h-4 w-4 mt-0.5 flex-shrink-0 text-white" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M16.704 4.153a.75.75 0 01.143 1.052l-8 10.5a.75.75 0 01-1.127.075l-4.5-4.5a.75.75 0 011.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 011.05-.143z" clipRule="evenodd" />
                </svg>
                <span>{item}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-2 gap-4">
          <div className="group relative rounded-xl overflow-hidden border border-neutral-900 shadow-xl shadow-neutral-900/25 ring-1 ring-white/10">
            <img
              src="https://images.unsplash.com/photo-1644158767445-79390e879319?q=80&w=2950&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
              alt="Industrial Robots"
              width={500}
              height={500}
              className="object-cover h-32 md:h-44 lg:h-56 w-full transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/0 to-black/0" />
            <p className="absolute bottom-2.5 left-3.5 text-[11px] font-medium tracking-wide text-white">
              Connected Operations
            </p>
          </div>
          <div className="group relative rounded-xl overflow-hidden border border-neutral-200 dark:border-white/10 shadow-lg shadow-neutral-900/5">
            <img
              src="https://plus.unsplash.com/premium_photo-1743965457287-fb51c14e868f?q=80&w=2064&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
              alt="Real World Observability"
              width={500}
              height={500}
              className="object-cover h-32 md:h-44 lg:h-56 w-full transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/0 to-black/0" />
            <p className="absolute bottom-2.5 left-3.5 text-[11px] font-medium tracking-wide text-white/90">
              Real-World Observability
            </p>
          </div>
          <div className="group relative rounded-xl overflow-hidden border border-neutral-900 shadow-xl shadow-neutral-900/25 ring-1 ring-white/10">
            <img 
              src="https://images.unsplash.com/photo-1664854953181-b12e6dda8b7c?auto=format&fit=crop&w=800&q=80"
              alt="Connected Sensors"
              width={500}
              height={500}
              className="object-cover h-32 md:h-44 lg:h-56 w-full transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/0 to-black/0" />
            <p className="absolute bottom-2.5 left-3.5 text-[11px] font-medium tracking-wide text-white">
              Every Data Point, Pinned
            </p>
          </div>
          <div className="group relative rounded-xl overflow-hidden border border-neutral-900 shadow-xl shadow-neutral-900/25 ring-1 ring-white/10">
            <img
              src="https://images.unsplash.com/photo-1688812272577-26ebc2fda742?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NDZ8fHBoeXNpY3N8ZW58MHx8MHx8fDA%3D"
              alt="Digital Twin Visualization"
              width={500}
              height={500}
              className="object-cover h-32 md:h-44 lg:h-56 w-full transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/0 to-black/0" />
            <p className="absolute bottom-2.5 left-3.5 text-[11px] font-medium tracking-wide text-white">
              The 4D Twin
            </p>
          </div>
        </div>
      </div>
    ),
  },
];

  return (
    <div className="min-h-screen w-full flex items-center justify-center">
      <div className="relative w-full max-w-9xl p-4">
        <Timeline data={data} />
      </div>
    </div>
  );
}


function AddStoryButton() {
  return (
    <button
      className={cn(
        "relative flex flex-col items-center gap-2 group cursor-pointer"
      )}
      aria-label="Add your story"
    >
      <div className="relative">
        <div className="w-[72px] h-[72px] rounded-full p-1">
          <div
            className={cn(
              "w-full h-full rounded-full flex items-center justify-center",
              "border-2 border-dashed border-muted-foreground/40",
              "bg-muted/30 transition-all duration-200",
              "group-hover:border-muted-foreground/60 group-hover:bg-muted/50"
            )}
          >
            <User className="w-7 h-7 text-muted-foreground/50" />
          </div>
        </div>
        <motion.div
          className="absolute bottom-0 right-0 w-6 h-6 rounded-full bg-primary flex items-center justify-center shadow-sm"
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.95 }}
        >
          <Plus className="w-4 h-4 text-primary-foreground" strokeWidth={2.5} />
        </motion.div>
      </div>
      <span className="text-xs text-muted-foreground truncate max-w-[80px]">
        Add Viz
      </span>
    </button>
  );
}

const users = [
  {
    username: "Footfall NYC",
    avatar: "https://api.dicebear.com/6.x/adventurer-neutral/svg?seed=Yuki+Tanaka",
    timestamp: new Date(Date.now() - 25 * 60 * 1000).toISOString(),
    stories: [
      { id: "yuki-1", type: "image", src: "https://images.unsplash.com/photo-1493976040374-85c8e12f0c0e?w=800&h=1200&fit=crop" },
      { id: "yuki-2", type: "video", src: "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerJoyrides.mp4" },
      { id: "yuki-3", type: "image", src: "https://images.unsplash.com/photo-1545569341-9eb8b30979d9?w=800&h=1200&fit=crop" },
    ],
  },
  {
    username: "Sales Q2",
    avatar: "https://api.dicebear.com/6.x/adventurer-neutral/svg?seed=Matt+Cooper",
    timestamp: new Date(Date.now() - 2 * 60 * 60 * 1000).toISOString(),
    stories: [
      { id: "matt-1", type: "video", src: "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerBlazes.mp4" },
      { id: "matt-2", type: "image", src: "https://images.unsplash.com/photo-1534438327276-14e5300c3a48?w=800&h=1200&fit=crop" },
    ],
  },
  {
    username: "Product Sales",
    avatar: "https://api.dicebear.com/6.x/adventurer-neutral/svg?seed=Sofia+Martinez",
    timestamp: new Date(Date.now() - 3 * 60 * 60 * 1000).toISOString(),
    stories: [
      { id: "sofia-1", type: "image", src: "https://images.unsplash.com/photo-1504674900247-0877df9cc836?w=800&h=1200&fit=crop" },
      { id: "sofia-2", type: "image", src: "https://images.unsplash.com/photo-1565299624946-b28f40a0ae38?w=800&h=1200&fit=crop" },
      { id: "sofia-3", type: "video", src: "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerEscapes.mp4" },
      { id: "sofia-4", type: "image", src: "https://images.unsplash.com/photo-1567620905732-2d1ec7ab7445?w=800&h=1200&fit=crop" },
    ],
  },
  {
    username: "Cx Returns",
    avatar: "https://api.dicebear.com/6.x/adventurer-neutral/svg?seed=Richard+Weber",
    timestamp: new Date(Date.now() - 5 * 60 * 60 * 1000).toISOString(),
    stories: [
      { id: "richard-1", type: "image", src: "https://images.unsplash.com/photo-1469474968028-56623f02e42e?w=800&h=1200&fit=crop" },
      { id: "richard-2", type: "video", src: "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerFun.mp4" },
    ],
  },
  {
    username: "Clickstream",
    avatar: "https://api.dicebear.com/6.x/adventurer-neutral/svg?seed=Emma+OBrien",
    timestamp: new Date(Date.now() - 7 * 60 * 60 * 1000).toISOString(),
    stories: [
      { id: "emma-1", type: "image", src: "https://images.unsplash.com/photo-1579783902614-a3fb3927b6a5?w=800&h=1200&fit=crop" },
      { id: "emma-2", type: "video", src: "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerMeltdowns.mp4" },
    ],
  },
  {
    username: "Hourly Sales",
    avatar: "https://api.dicebear.com/6.x/adventurer-neutral/svg?seed=Jake+Morrison",
    timestamp: new Date(Date.now() - 10 * 60 * 60 * 1000).toISOString(),
    stories: [
      { id: "jake-1", type: "image", src: "https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=800&h=1200&fit=crop" },
      { id: "jake-2", type: "video", src: "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerJoyrides.mp4" },
      { id: "jake-3", type: "image", src: "https://images.unsplash.com/photo-1519681393784-d120267933ba?w=800&h=1200&fit=crop" },
    ],
  },
  {
    username: "Time Travel",
    avatar: "https://api.dicebear.com/6.x/adventurer-neutral/svg?seed=Alex+Chen",
    timestamp: new Date(Date.now() - 12 * 60 * 60 * 1000).toISOString(),
    stories: [
      { id: "alex-1", type: "video", src: "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerBlazes.mp4" },
      { id: "alex-2", type: "video", src: "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerEscapes.mp4" },
    ],
  },
];

function Demo() {
  return (
    <div className="w-full mt-12 max-w-3xl mx-auto px-4">
      <h3 className="text-lg font-semibold mb-3 px-1">We are building Features to drive Data storytelling in meaningful ways</h3>
      <div className="flex gap-4 overflow-x-auto py-2 px-1 [&::-webkit-scrollbar]:hidden md:[&::-webkit-scrollbar]:block md:[&::-webkit-scrollbar]:h-1.5 [&::-webkit-scrollbar-track]:bg-transparent [&::-webkit-scrollbar-thumb]:bg-muted-foreground/20 [&::-webkit-scrollbar-thumb]:rounded-full hover:[&::-webkit-scrollbar-thumb]:bg-muted-foreground/30">
        <AddStoryButton />
        {users.map((user) => (
          <StoryViewer
            key={user.username}
            stories={user.stories}
            username={user.username}
            avatar={user.avatar}
            timestamp={user.timestamp}
            onStoryView={() => {}}
            onAllStoriesViewed={() => {}}
          />
        ))}
      </div>
    </div>
  );
}

function DemoOne() {
   return (
    // 1. LIGHT MODE: 'bg-zinc-50' (White Page) -> Component will be Black
    // 2. DARK MODE: 'dark:bg-black' (Black Page) -> Component will be White
    <div className="min-h400-screen w-full flex items-center justify-center bg-zinc-50 dark:bg-black p-4 transition-colors duration-300">
      
      <div className="w-full max-w-8xl">
        {/* <FlipTextReveal word="Time Travel for the Physical World" /> */}
        <FlipTextReveal/>
      </div>
 
    </div>
  );
}

function SplineSceneBasic() {
  return (
    <Card className="w-full md:h-[500px] min-h-[640px] md:min-h-0 bg-black/[0.96] relative overflow-hidden md:flex">
      <Spotlight
        className="-top-40 left-0 md:left-60 md:-top-20"
        fill="white"
      />

      {/* Spline scene: full-card background on mobile, right half on desktop */}
      <div className="absolute inset-0 md:relative md:flex-1 opacity-30 md:opacity-100">
        <SplineScene 
          scene="https://prod.spline.design/kZDDjO5HuC9GJUM2/scene.splinecode"
          className="w-full h-full"
        />
      </div>

      {/* Text content: overlays the background on mobile, occupies LEFT HALF only on desktop */}
      <div className="relative z-10 flex flex-col justify-center items-center md:items-start text-center md:text-left p-8 md:p-10 md:w-1/2">
        {/* eyebrow badge */}
        <div className="inline-flex items-center gap-2.5 px-4 py-1.5 mb-6 rounded-full border border-white/15 bg-black/40 md:bg-white/5 backdrop-blur-sm">
          <span className="relative flex h-2 w-2">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-white opacity-60"></span>
            <span className="relative inline-flex rounded-full h-2 w-2 bg-white"></span>
          </span>
          <span className="text-[11px] font-semibold tracking-[0.2em] uppercase text-neutral-300">
            Spatial Analytics · Digital Twin
          </span>
        </div>

        {/* headline */}
        <h1 className="text-4xl md:text-5xl xl:text-6xl font-bold tracking-tight leading-[1.05] bg-clip-text text-transparent bg-gradient-to-b from-neutral-50 to-neutral-400">
          The physical world is not a dashboard
        </h1>

        {/* subheadline */}
        <p className="mt-5 text-neutral-300 md:text-neutral-400 max-w-lg text-base md:text-lg leading-relaxed">
          Traditional BI flattens your <span className="text-white font-medium">operations </span>
          into <span className="text-white font-medium">2D</span> charts. <span className="text-white font-medium">Smarlytics rebuilds your physical world </span>
           mapping every metric to its space - a live digital twin of your operations.
        </p>

        {/* CTAs */}
        <div className="mt-7 flex flex-col sm:flex-row w-full sm:w-auto items-stretch sm:items-center gap-3">
          <button className="px-6 py-3 rounded-lg text-sm font-semibold text-black bg-gradient-to-b from-white to-neutral-300 shadow-[0_0_20px_rgba(255,255,255,0.25)] hover:shadow-[0_0_32px_rgba(255,255,255,0.4)] hover:-translate-y-0.5 transition-all duration-200">
            Request Early Access
          </button>
          <button className="px-6 py-3 rounded-lg text-sm font-semibold text-black bg-gradient-to-b from-[#EDF3FA] to-[#C9D6E4] border border-white/40 shadow-[0_0_20px_rgba(201,214,228,0.3)] hover:shadow-[0_0_36px_rgba(201,214,228,0.45)] hover:-translate-y-0.5 transition-all duration-200">
            Solutions Catalog
          </button>
          <button className="px-6 py-3 rounded-lg text-sm font-semibold text-neutral-200 border border-white/20 bg-black/40 sm:bg-white/5 backdrop-blur-sm hover:bg-white/10 hover:-translate-y-0.5 transition-all duration-200">
            Read the Whitepaper ↓
          </button>
        </div>

        {/* trust line */}
        <div className="mt-8 hidden sm:flex flex-wrap items-center gap-2 justify-center md:justify-start">
          <span className="text-[11px] font-medium tracking-[0.15em] uppercase text-neutral-500 mr-1">
            Runs natively on
          </span>
          {['AWS', 'GCP', 'Azure', 'Snowflake', 'Databricks', 'ClickHouse'].map((p) => (
            <span
              key={p}
              className="px-2.5 py-1 text-xs font-medium text-neutral-400 border border-white/10 bg-white/5 rounded-md"
            >
              {p}
            </span>
          ))}
        </div>
      </div>
    </Card>
  )
}

function GlowingEffectDemo() {
  return (
    <ul className="mt-8 grid grid-cols-1 grid-rows-none gap-4 md:grid-cols-12 md:grid-rows-3 lg:gap-4 xl:max-h-[34rem] xl:grid-rows-2">
      <GridItem
        area="md:[grid-area:1/1/2/7] xl:[grid-area:1/1/2/5]"
        icon={<Box className="h-4 w-4" />}
        title="Prebuilt connectors for real world data sources"
        description="Prebuilt connectors stream sensor feeds, Databases, POS and IT/OT systems."
      />
      <GridItem
        area="md:[grid-area:1/7/2/13] xl:[grid-area:2/1/3/5]"
        icon={<Settings className="h-4 w-4" />}
        title="Runs native on your lakehouse"
        description="spatial layer on top of Warehouses — your existing tables, governance, zero additional infrastructure."
      />
      <GridItem
        area="md:[grid-area:2/1/3/7] xl:[grid-area:1/5/3/8]"
        icon={<Lock className="h-4 w-4" />}
        title="Every metric has an address"
        description="3D + time-series analytics pin each KPI to the exact space and moment it happened — the dead zone, the queue, the hour it went wrong."
      />
      <GridItem
        area="md:[grid-area:2/7/3/13] xl:[grid-area:1/8/2/13]"
        icon={<Sparkles className="h-4 w-4" />}
        title="Operational data + world models"
        description="Generative world model grounded in real-time data — replay shifts, simulate changes, and validate impact before committing."
      />
      <GridItem
        area="md:[grid-area:3/1/4/13] xl:[grid-area:2/8/3/13]"
        icon={<Search className="h-4 w-4" />}
        title="From insight to alignment in seconds"
        description="Turn spatial findings into a short, shareable video brief that every stakeholder instantly understands."
      />
    </ul>
  );
}

interface GridItemProps {
  area: string;
  icon: React.ReactNode;
  title: string;
  description: React.ReactNode;
}

const GridItem = ({ area, icon, title, description }: GridItemProps) => {
  return (
    <li className={cn("min-h-[14rem] list-none", area)}>
      <div className="relative h-full rounded-[1.25rem] border-[0.75px] border-border p-2 md:rounded-[1.5rem] md:p-3">
        <GlowingEffect
          spread={40}
          glow={true}
          disabled={false}
          proximity={64}
          inactiveZone={0.01}
          borderWidth={3}
        />
        <div className="relative flex h-full flex-col justify-between gap-6 overflow-hidden rounded-xl border-[0.75px] bg-background p-6 shadow-sm dark:shadow-[0px_0px_27px_0px_rgba(45,45,45,0.3)] md:p-6">
          <div className="relative flex flex-1 flex-col justify-between gap-3">
            <div className="w-fit rounded-lg border-[0.75px] border-border bg-muted p-2">
              {icon}
            </div>
            <div className="space-y-3">
              <h3 className="pt-0.5 text-xl leading-[1.375rem] font-semibold font-sans tracking-[-0.04em] md:text-2xl md:leading-[1.875rem] text-balance text-foreground">
                {title}
              </h3>
              <h2 className="[&_b]:md:font-semibold [&_strong]:md:font-semibold font-sans text-sm leading-[1.125rem] md:text-base md:leading-[1.375rem] text-muted-foreground">
                {description}
              </h2>
            </div>
          </div>
        </div>
      </div>
    </li>
  );
};


const timelineData = [
  {
    id: 1,
    title: "Connectors",
    date: "June 2026",
    content: "Pre-built connectors for common data sources.",
    category: "Planning",
    icon: Calendar,
    relatedIds: [2, 3],
    status: "completed",
    energy: 100,
  },
  {
    id: 2,
    title: "Transform",
    date: "Aug 2026",
    content: "Pre-built data transformers for multi-modal data.",
    category: "Pipeline",
    icon: FileText,
    relatedIds: [1, 3],
    status: "completed",
    energy: 100,
  },
  {
    id: 3,
    title: "Development",
    date: "Sept 2026",
    content: "Build custom transformers and visualization components.",
    category: "Development",
    icon: Code,
    relatedIds: [2, 4],
    status: "in-progress",
    energy: 80,
  },
  {
    id: 4,
    title: "Visualize",
    date: "Dec 2026",
    content: "Convert data into interactive 4D visualizations.",
    category: "Testing",
    icon: User,
    relatedIds: [3, 5],
    status: "in-progress",
    energy: 60,
  },
  {
    id: 5,
    title: "Deploy",
    date: "Dec 2026",
    content: "Deploy and release storied insights.",
    category: "Release",
    icon: Clock,
    relatedIds: [4],
    status: "in-progress",
    energy: 40,
  },
];


function HeroSection() {
  const images = [HeroImages, livespaces];
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 3000); // Change image every 3 seconds
    return () => clearInterval(interval); // Cleanup interval on unmount
  }, [images.length]);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="hero">
      <div className="hero-content">
        <h1>Implementation Partners <span>for Founders</span></h1>
        <p className="font-bold" style={{ fontSize: '1.5rem' }}>What does going to market <span className="font-bold text-blue-600">3x faster</span> mean for your idea?</p>
        <p><span className="font-bold">What we do is</span> - empower Founders to launch products and features faster. Smarlytics leverages expertise, speed and price efficiency to bring founders' ideas to life.</p>
        <button className="cta-btn" onClick={() => scrollToSection('signup')}>Contact Smarlytics</button>
      </div>
      <div className="hero-image flex items-center justify-center">
        <img
          src={images[currentIndex]}
          alt="Carousel Image"
          className="object-contain w-full h-auto max-h-[700px] rounded-lg transition-opacity duration-500"
        />
      </div>
    </section>
  );
}

function FeaturesSection() {
  return (
    <section id="features" className="py-16 px-4 md:px-8 bg-white">
      <div className="max-w-8xl mx-12">
        <div className="flex flex-col md:flex-row justify-between items-start gap-8 mb-12">
          <h2 className="text-4xl font-bold text-gray-900 text-left">
            Faster time to market with Smarlytics
          </h2>
          <p className="text-lg text-gray-600 text-left self-center md:self-star">
            <span className="font-bold text-gray-900">Priced as a subscription model</span> - engineering teams are aligned on a skill-need basis covering all demands for a modern application build.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {/* Calendar Card */}
          <div className="bg-blue-500 rounded-3xl p-6 text-white relative overflow-hidden">
            <h3 className="text-xl font-semibold mb-4 text-left">
              Development Firm Focus
            </h3>
            <p className="text-sm mb-6 text-left">
              Helping founders bring their ideas to life and get to market sooner.
            </p>
            <div className="mt-4">
              <svg
                className="w-full h-48"
                viewBox="0 0 200 160"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                {/* Calendar Header */}
                <rect x="20" y="20" width="160" height="30" rx="8" fill="white" fillOpacity="0.2" />
                <rect x="30" y="32" width="20" height="6" rx="2" fill="white" fillOpacity="0.9" />
                <rect x="150" y="32" width="20" height="6" rx="2" fill="white" fillOpacity="0.9" />

                {/* Calendar Grid */}
                <rect x="20" y="50" width="160" height="90" rx="8" fill="white" fillOpacity="0.1" />

                {/* Calendar Days */}
                <g opacity="0.9">
                  {/* Week days header */}
                  <rect x="30" y="60" width="20" height="6" rx="2" fill="white" fillOpacity="0.5" />
                  <rect x="60" y="60" width="20" height="6" rx="2" fill="white" fillOpacity="0.5" />
                  <rect x="90" y="60" width="20" height="6" rx="2" fill="white" fillOpacity="0.5" />
                  <rect x="120" y="60" width="20" height="6" rx="2" fill="white" fillOpacity="0.5" />
                  <rect x="150" y="60" width="20" height="6" rx="2" fill="white" fillOpacity="0.5" />

                  {/* Calendar numbers */}
                  <rect x="30" y="80" width="20" height="20" rx="4" fill="white" fillOpacity="0.7" />
                  <text x="37" y="94" fill="#2563EB" fontSize="12">1</text>

                  <rect x="60" y="80" width="20" height="20" rx="4" fill="white" fillOpacity="0.2" />
                  <text x="67" y="94" fill="white" fontSize="12">2</text>

                  {/* Highlighted day */}
                  <rect x="90" y="80" width="20" height="20" rx="4" fill="#2563EB" />
                  <text x="97" y="94" fill="white" fontSize="12">3</text>

                  {/* Numbers continue... */}
                </g>

                {/* Price overlay */}
                <rect x="30" y="120" width="80" height="12" rx="6" fill="white" fillOpacity="0.2" />
                <text x="40" y="130" fill="white" fontSize="10">329.42 • 189.91</text>
              </svg>
            </div>
          </div>

          {/* Real-Time Updates Card */}
          <div className="bg-white border border-gray-200 rounded-3xl p-6 row-span-2 flex flex-col items-start justify-between relative overflow-hidden">
            <div>
              <h3 className="text-xl font-semibold mb-4 text-gray-900 text-left">
                Full Product Build
              </h3>
              <p className="text-md text-gray-600 mb-2 text-left">
                With capabilities to take ideas from inception to go-live.
              </p>
              <p className="text-md text-gray-600 text-left">
                <span className="font-bold text-gray-900">Start from <span className="font-bold text-blue-600">$8000*</span> per month</span>
              </p>
            </div>
            <div className="relative w-full h-[400px]">
              <svg
                className="w-full h-full"
                viewBox="0 0 300 400"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                {/* Phone outline */}
                <rect x="60" y="20" width="180" height="360" rx="20" fill="#F3F4F6" />
                <rect x="70" y="30" width="160" height="340" rx="15" fill="white" />

                {/* Notification banner */}
                <rect x="80" y="50" width="140" height="80" rx="10" fill="#2563EB" />
                <circle cx="100" cy="70" r="15" fill="white" fillOpacity="0.9" />
                <rect x="125" y="65" width="80" height="10" rx="5" fill="white" fillOpacity="0.9" />
                <rect x="125" y="85" width="60" height="8" rx="4" fill="white" fillOpacity="0.6" />

                {/* Event details */}
                <rect x="80" y="150" width="140" height="60" rx="8" fill="#F3F4F6" />
                <circle cx="100" cy="170" r="12" fill="#2563EB" />
                <rect x="120" y="165" width="70" height="8" rx="4" fill="#4B5563" />
                <rect x="120" y="180" width="50" height="6" rx="3" fill="#6B7280" />
              </svg>
            </div>
          </div>

          {/* Split Payment Card */}
          <div className="bg-purple-400 rounded-3xl p-6 text-white relative overflow-hidden">
            <h3 className="text-xl font-semibold mb-4 text-left">
              Product Advisory & Strategy
            </h3>
            <p className="text-sm mb-6 text-left">
              With accelerator features like Google Auth, payment integrations, etc.
            </p>
            <div className="mt-4">
              <svg
                className="w-full h-48"
                viewBox="0 0 200 160"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                {/* Wallet interface */}
                <rect x="40" y="20" width="120" height="120" rx="12" fill="white" fillOpacity="0.2" />

                {/* Card design */}
                <rect x="50" y="40" width="100" height="60" rx="8" fill="white" fillOpacity="0.9" />
                <rect x="60" y="50" width="40" height="6" rx="3" fill="#9333EA" />
                <rect x="60" y="80" width="60" height="8" rx="4" fill="#9333EA" />

                {/* Payment details */}
                <circle cx="60" cy="120" r="10" fill="white" fillOpacity="0.9" />
                <circle cx="90" cy="120" r="10" fill="white" fillOpacity="0.9" />
                <circle cx="120" cy="120" r="10" fill="white" fillOpacity="0.9" />
              </svg>
            </div>
          </div>

          {/* In-App Messaging Card */}
          <div className="bg-emerald-600 rounded-3xl p-6 text-white relative overflow-hidden">
            <h3 className="text-xl font-semibold mb-4 text-left">
              Blended Team Approach
            </h3>
            <p className="text-sm mb-6 text-left">
              Cost-effective with skills ranging from cross-platform app development, Data & AI tailored for every budget.
            </p>
            <div className="mt-4">
              <svg
                className="w-full h-48"
                viewBox="0 0 200 160"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                {/* Message bubbles */}
                <rect x="30" y="40" width="100" height="40" rx="20" fill="white" fillOpacity="0.2" />
                <rect x="40" y="55" width="80" height="10" rx="5" fill="white" fillOpacity="0.9" />

                <rect x="70" y="90" width="100" height="40" rx="20" fill="white" fillOpacity="0.9" />
                <rect x="80" y="105" width="80" height="10" rx="5" fill="#059669" />

                {/* Notification badge */}
                <circle cx="160" cy="40" r="15" fill="red" />
                <text x="155" y="45" fill="white" fontSize="12">1</text>
              </svg>
            </div>
          </div>

          {/* Menu Access Card */}
          <div className="bg-orange-300 rounded-3xl p-6 text-white relative overflow-hidden">
            <h3 className="text-xl font-semibold mb-4 text-left">
              End-to-End Product Support
            </h3>
            <p className="text-sm mb-6 text-left">
              From product development to go-to-market strategy paired with coaching for founders
            </p>
            <div className="mt-4">
              <svg
                className="w-full h-48"
                viewBox="0 0 200 160"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                {/* Menu paper */}
                <rect x="40" y="20" width="120" height="120" rx="8" fill="white" fillOpacity="0.2" />

                {/* Menu items */}
                <rect x="50" y="40" width="100" height="8" rx="4" fill="white" fillOpacity="0.9" />
                <rect x="50" y="60" width="80" height="8" rx="4" fill="white" fillOpacity="0.7" />
                <rect x="50" y="80" width="90" height="8" rx="4" fill="white" fillOpacity="0.8" />
                <rect x="50" y="100" width="70" height="8" rx="4" fill="white" fillOpacity="0.6" />

                {/* Price tags */}
                <rect x="130" y="40" width="20" height="8" rx="4" fill="white" fillOpacity="0.9" />
                <rect x="130" y="60" width="20" height="8" rx="4" fill="white" fillOpacity="0.7" />
                <rect x="130" y="80" width="20" height="8" rx="4" fill="white" fillOpacity="0.8" />
                <rect x="130" y="100" width="20" height="8" rx="4" fill="white" fillOpacity="0.6" />
              </svg>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

// function AdditionalFeaturesSection() {
//   return (
//     <section className="additional-features">
//       <div className="feature">
//       <h3>Find the best events happening near you and book your spot instantly.</h3>
//         <img src={Event} alt="Find events" />

//       </div>
//       <div className="feature">
//       <h3>Communicate with promoters and other users for a smooth event experience</h3>
//         <img src={NotificationOne} />

//       </div>
//       <div className="feature">
//       <h3>Receive instant notifications about your bookings and event changes.</h3>
//         <img src={NotificationTwo} />

//       </div>
//     </section>
//   );
// }

function CountdownSection() {
  // Set your target date here
  const today = new Date();
  const nextMonth = new Date(today.setMonth(today.getMonth() + 1));
  const LAUNCH_DATE = new Date(nextMonth.setHours(0, 0, 0, 0)).getTime();


  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  function calculateTimeLeft() {
    const difference = LAUNCH_DATE - new Date().getTime();

    return {
      days: Math.floor(difference / (1000 * 60 * 60 * 24)),
      hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
      minutes: Math.floor((difference / 1000 / 60) % 60),
      seconds: Math.floor((difference / 1000) % 60),
    };
  }

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  // Helper to add leading zeros
  const formatNumber = (num) => String(num).padStart(2, '0');

  return (
    <section id="countdown" className='countdown-section'>
      <section className="countdown">
        <h2>A month away from your next product or feature launch</h2>
        <div className="timer">
          <div className="time-unit">
            <span className="number">{formatNumber(timeLeft.days)}</span>
            <span className="label">Days</span>
          </div>
          <div className="time-unit">
            <span className="number">{formatNumber(timeLeft.hours)}</span>
            <span className="label">Hours</span>
          </div>
          <div className="time-unit">
            <span className="number">{formatNumber(timeLeft.minutes)}</span>
            <span className="label">Minutes</span>
          </div>
          <div className="time-unit">
            <span className="number">{formatNumber(timeLeft.seconds)}</span>
            <span className="label">Seconds</span>
          </div>
        </div>
        <button className="subscribe-btn">Contact Us</button>
      </section>
    </section>
  );
}

// const YOUR_SCRIPT_URL = "https://script.google.com/macros/s/AKfycbwgFuX5X7hvX0a85aZJStcSw9WclJoYx4YP6Yskqu-vnXaeEfHCa9HFCPB09pvkLyhW/exec"
// const resend = new Resend('re_E9Ck9xJ4_8VbvZrVCfgzhnzyE4Ja5PafH');

function SignUpSection() {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    workEmail: '',
    company: '',
    role: ''
  });
  const [isLoading, setIsLoading] = useState(false);
  const [notification, setNotification] = useState({ show: false, message: '', type: '' });

  // Light-theme input styles — the signup section sits on a light background,
  // so NO text-white / border-white here (that's what made the form invisible)
  const inputClass =
    'w-full px-4 py-2.5 rounded-lg bg-black/[0.04] border border-black/15 text-gray-900 placeholder-gray-400 text-sm outline-none transition-colors focus:border-gray-900 focus:bg-black/[0.06] disabled:opacity-50';
  const labelClass = 'block text-xs font-medium text-gray-600 mb-1.5';

  const showNotification = (message, type) => {
    setNotification({ show: true, message, type });
    setTimeout(() => {
      setNotification({ show: false, message: '', type: '' });
    }, 3000);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    const cleanup = (form, iframe) => {
      try {
        if (form && form.parentNode) {
          form.parentNode.removeChild(form);
        }
        if (iframe && iframe.parentNode) {
          iframe.parentNode.removeChild(iframe);
        }
      } catch (error) {
        console.error('Cleanup error:', error);
      }
    };

    const form = document.createElement('form');
    form.method = 'POST';
    // form.action = YOUR_SCRIPT_URL;
    form.target = 'hidden-iframe';
    form.style.display = 'none';

    Object.entries(formData).forEach(([key, value]) => {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = key;
      input.value = value;
      form.appendChild(input);
    });

    const iframe = document.createElement('iframe');
    iframe.name = 'hidden-iframe';
    iframe.style.display = 'none';
    iframe.setAttribute('sandbox', 'allow-same-origin allow-scripts allow-forms');

    let submitted = false;

    iframe.onload = async () => {
      if (!submitted) {
        submitted = true;
        return;
      }

      try {
        await fetch('https://livespaces-prod.ue.r.appspot.com/api/waitlists', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            data: {
              email: formData.workEmail,
              firstName: formData.firstName,
              lastName: formData.lastName,
              company: formData.company,
              role: formData.role
            }
          })
        });
      } catch (error) {
        console.error('Failed to send notification:', error);
      }

      setIsLoading(false);
      showNotification("You're on the list. We'll be in touch within 48 hours.", 'success');
      setFormData({ firstName: '', lastName: '', workEmail: '', company: '', role: '' });
      cleanup(form, iframe);
    };

    iframe.onerror = () => {
      setIsLoading(false);
      showNotification('Failed to submit. Please try again.', 'error');
      cleanup(form, iframe);
    };

    document.body.appendChild(iframe);
    document.body.appendChild(form);

    form.submit();

    setTimeout(() => {
      if (isLoading) {
        setIsLoading(false);
        showNotification('Request timed out. Please try again.', 'error');
        cleanup(form, iframe);
      }
    }, 10000);
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const Toast = ({ message, type }) => (
    <div
      className={`fixed bottom-4 right-4 px-5 py-4 rounded-lg shadow-2xl transition-opacity duration-300 text-white max-w-md z-50 text-sm font-medium ${
        type === 'success' ? 'bg-emerald-600' : 'bg-red-600'
      }`}
      style={{
        animation: 'slideIn 0.5s ease-out forwards'
      }}
    >
      {message}
    </div>
  );

  return (
    <section id="signup" className="signup">
      <><Hero /></>

      <div className="signup-form">
        <div className="step">
          <p className="text-xs font-mono uppercase tracking-[0.25em] text-gray-400 mb-3">
            Limited early access
          </p>
          <h3 className="text-3xl font-bold tracking-tight text-gray-900">
            Get early access
          </h3>
          <p className="text-gray-500 text-sm mt-2 max-w-md">
            Join the waitlist for a forward-deployed pilot on your own data —
            live in weeks, not quarters.
          </p>

          <form onSubmit={handleSubmit} className="mt-8 space-y-4">
            {/* Row 1 — identity */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div>
                <label htmlFor="firstName" className={labelClass}>
                  First name
                </label>
                <input
                  id="firstName"
                  type="text"
                  name="firstName"
                  value={formData.firstName}
                  onChange={handleChange}
                  required
                  disabled={isLoading}
                  autoComplete="given-name"
                  placeholder="Ada"
                  className={inputClass}
                />
              </div>
              <div>
                <label htmlFor="lastName" className={labelClass}>
                  Last name
                </label>
                <input
                  id="lastName"
                  type="text"
                  name="lastName"
                  value={formData.lastName}
                  onChange={handleChange}
                  required
                  disabled={isLoading}
                  autoComplete="family-name"
                  placeholder="Lovelace"
                  className={inputClass}
                />
              </div>
            </div>

            {/* Row 2 — work email */}
            <div>
              <label htmlFor="workEmail" className={labelClass}>
                Work email
              </label>
              <input
                id="workEmail"
                type="email"
                name="workEmail"
                value={formData.workEmail}
                onChange={handleChange}
                required
                disabled={isLoading}
                autoComplete="email"
                placeholder="ada@company.com"
                className={inputClass}
              />
            </div>

            {/* Row 3 — qualification */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div>
                <label htmlFor="company" className={labelClass}>
                  Company
                </label>
                <input
                  id="company"
                  type="text"
                  name="company"
                  value={formData.company}
                  onChange={handleChange}
                  required
                  disabled={isLoading}
                  autoComplete="organization"
                  placeholder="Acme Retail Co."
                  className={inputClass}
                />
              </div>
              <div>
                <label htmlFor="role" className={labelClass}>
                  Role
                </label>
                <select
                  id="role"
                  name="role"
                  value={formData.role}
                  onChange={handleChange}
                  required
                  disabled={isLoading}
                  className={`${inputClass} appearance-none`}
                >
                  <option value="" disabled>
                    Select your role
                  </option>
                  <option value="executive">Executive / C-suite</option>
                  <option value="operations">Operations</option>
                  <option value="data">Data / Analytics</option>
                  <option value="it">IT / Engineering</option>
                  <option value="other">Other</option>
                </select>
              </div>
            </div>

            {/* Submit */}
            <button
              type="submit"
              disabled={isLoading}
              className="w-full mt-6 py-3 rounded-lg bg-gray-900 text-white font-semibold text-sm tracking-wide transition-all hover:bg-gray-800 active:scale-[0.99] disabled:opacity-70 disabled:cursor-not-allowed relative"
            >
              <span className={isLoading ? 'invisible' : ''}>
                Request early access
              </span>
              {isLoading && (
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                </div>
              )}
            </button>

            <p className="text-center text-xs text-gray-400 pt-1">
              No credit card. No infrastructure changes. We deploy on your data.
            </p>
          </form>
        </div>
      </div>

      {notification.show && <Toast message={notification.message} type={notification.type} />}
    </section>
  );
}


function Footer() {
  return (
    <footer className="footer">
      {/* Main footer content */}
      <div className="footer-content">
        {/* <div className="footer-left">
          <div className="logo">
            <img src={LOGO} alt="VIPROOST" />
            <span>VIPROOST</span>
          </div>
        </div> */}

        <nav className="footer-links">
          {/* <a href="#home">Home</a>
          <a href="#about">About us</a>
          <a href="#features">Features</a>
          <a href="#contact">Contact us</a> */}
        </nav>

        {/* <div className="social-links">
          <a href="#" className="social-button" aria-label="Facebook">
            <Facebook size={20} />
          </a>
          <a href="#" className="social-button" aria-label="Twitter">
            <Twitter size={20} />
          </a>
          <a href="#" className="social-button" aria-label="Instagram">
            <Instagram size={20} />
          </a>
          <a href="#" className="social-button" aria-label="LinkedIn">
            <Linkedin size={20} />
          </a>
        </div> */}
      </div>

      <div className="divider" />

      {/* Footer bottom */}
      <div className="footer-bottom">
        <p className="copyright">&copy; 2026 Smarlytics. All rights reserved.</p>
        <div className="legal-links">
          <a href="/privacy">Privacy Policy</a>
          <a href="/terms">Terms of Service</a>

        </div>
      </div>
    </footer>
  );
}

export default App;

